import axios from 'axios';
import config from '@/api/config';

export default {
    request(method, uri, data = null, settings, forceToken) {
        let headers;
        if (!settings) {
            let mainToken = localStorage.getItem('access_token');
            let token = mainToken ? mainToken : localStorage.getItem('anonymous_token');
            console.log(`use force token?: uri:${uri} token: ${token} | forceToken:${forceToken}`)
            token = forceToken ? forceToken : token

            headers = {
                'airvote-language': localStorage.getItem('lang')
            };
            if(token) {
                headers.Authorization = 'Bearer ' + token
            }
        } else {
            headers = settings;
        }

        if (!method) {
            console.error('API function call requires method argument');
            return;
        }

        if (!uri) {
            console.error('API function call requires uri argument');
            return;
        }

        var url = process.env.VUE_APP_BASE_URL + uri;

        return new Promise((resolve, reject) => {
            axios({method, url, data, headers})
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    },
};
